import {
  Button,
  MessageBar,
  MessageBarBody,
  makeStyles,
  shorthands,
  tokens,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    rowGap: "12px",
    ...shorthands.padding("12px"),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    ...shorthands.border("1px", "solid", tokens.colorNeutralStroke2),
  },
  actions: { display: "flex", gap: "8px", flexWrap: "wrap" },
});

export function ValidationGate({
  onValidate,
  onModify,
  disabled,
}: {
  onValidate: () => void;
  onModify: () => void;
  disabled: boolean;
}) {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <MessageBar intent="success">
        <MessageBarBody>
          ✅ Toutes les informations sont collectées. Prêt à générer le brief ?
        </MessageBarBody>
      </MessageBar>
      <div className={styles.actions}>
        <Button appearance="primary" onClick={onValidate} disabled={disabled}>
          ✅ Valider &amp; Générer
        </Button>
        <Button appearance="secondary" onClick={onModify} disabled={disabled}>
          ✍️ Modifier
        </Button>
      </div>
    </div>
  );
}
